const IMAGE_SOURCE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
const AUDIO_SOURCE_TYPES = [
  'audio/mpeg',
  'audio/webm',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'video/webm', // some browsers report webm audio as video/webm
];

const VALID_TYPES = ['text/plain', 'text/markdown', 'application/pdf', ...IMAGE_SOURCE_TYPES, ...AUDIO_SOURCE_TYPES];
export const VALID_EXTENSIONS = ['.txt', '.md', '.pdf', '.jpg', '.jpeg', '.png', '.webp', '.mp3', '.webm', '.m4a'];
const MAX_MB = 10;
const MAX_SIZE = MAX_MB * 1024 * 1024;

export const UPLOAD_ERROR_MESSAGES = {
  size: `File is too large. Maximum size is ${MAX_MB}MB.`,
  type: `File type not supported. Only ${VALID_EXTENSIONS.join(', ')} are allowed.`,
  default: `Upload failed. Please try again.`,
} as const;

export const getContentType = (file: File): string => {
  if (file.type) return file.type;
  const ext = file.name.toLowerCase().split('.').pop();
  if (ext === 'md') return 'text/markdown';
  if (ext === 'txt') return 'text/plain';
  if (ext === 'pdf') return 'application/pdf';
  if (ext === 'jpg' || ext === 'jpeg') return 'image/jpeg';
  if (ext === 'png') return 'image/png';
  if (ext === 'webp') return 'image/webp';
  if (ext === 'mp3') return 'audio/mpeg';
  if (ext === 'webm') return 'audio/webm';
  if (ext === 'm4a') return 'audio/mp4';
  return '';
};

export const isAudioSourceType = (sourceType?: string | null): boolean => {
  return !!sourceType && (sourceType.startsWith('audio/') || sourceType === 'video/webm');
};

export const validateFile = (file: File): { valid: boolean; error: string | null } => {
  const contentType = getContentType(file);
  if (!VALID_TYPES.includes(contentType)) {
    return { valid: false, error: UPLOAD_ERROR_MESSAGES.type };
  }
  if (file.size > MAX_SIZE) {
    return { valid: false, error: UPLOAD_ERROR_MESSAGES.size };
  }
  return { valid: true, error: null };
};

export const getFileNameWithoutExtension = (fileName: string): string => {
  const lastDot = fileName.lastIndexOf('.');
  if (lastDot === -1) return fileName;
  return fileName.slice(0, lastDot);
};

export const getSupportedClipboardFiles = (files: FileList | null | undefined): File[] | null => {
  if (!files?.length) return null;

  const supportedFiles = Array.from(files).filter((file) => validateFile(file).valid);

  if (!supportedFiles.length) return null;

  return supportedFiles;
};
